import { useState, useEffect } from "react";
import './Volunteer_step_form.css'
import Breadcrumb_Comp from '../../common/common_components/breadcrumb_comp/Breadcrumb_Comp'
import Common_Title_2 from '../../common/common_components/common_title_2/Common_Title_2'
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import Step_one from './step-one/Step_one'
import Step_two from './step-two/Step_two'
import { useForm, FormProvider } from "react-hook-form";
import { useParams } from "react-router-dom";
import { GetALL } from "../../../features/admin/volunteerStepform/Slice";
import { useDispatch, useSelector } from "react-redux";
import { decodeId } from "../../../utils/common";
import { GetSIngleVolunteer } from "../../../features/admin/common/Slice";

const Volunteer_step_form = () => {

  const dispatch = useDispatch();
  const getall = useSelector((state) => state.volunteerstepform.getall);

  const { id, volunteer_id } = useParams();  // volunteer_id from URL (Edit case)

  const [page, setPage] = useState(0);
  const [subPage, setSubPage] = useState(0);

  const methods = useForm({
    mode: "onChange",
    defaultValues: {
      f_name: "",
      l_name: "",
      email: "",
      contact_no: "",
      volunteering_id: "",
      volunteer_id: "",

      learn_about_this_opening: "",
      volunteer_position_id: "",
      days_of_service_id: "",
      hours_of_service_id: "",
      joining_date: "",
      skills: "",
      live_omtapovan: false,
      want_volunteer: "",
      your_confirmation: "",
      have_you_volunteered: "",
    },
  });


  useEffect(() => {
    if (id) {
      methods.setValue("volunteering_id", decodeId(id));
    }
  }, [id]);

  const volunteer = useSelector((state) => state.common.volunteer);
  const getData = async (id) => {
    await dispatch(GetSIngleVolunteer(decodeId(id)));
  }
  useEffect(() => {
    if (id) {
      getData(id);
    }
  }, [id, dispatch]);


  useEffect(() => {
    if (volunteer_id) {
      dispatch(GetALL({ volunteer_id }));
    }
  }, [volunteer_id]);


  useEffect(() => {
    if (getall && volunteer_id) {
      const data = getall?.data?.Volunteers_Detail || getall?.data;

      methods.reset({
        f_name: getall?.data?.f_name || "",
        l_name: getall?.data?.l_name || "",
        email: getall?.data?.email || "",
        contact_no: getall?.data?.contact_no || "",
        volunteer_id: getall?.data?.id || "",
        volunteering_id: getall?.data?.volunteering_id || id,

        learn_about_this_opening: data?.learn_about_this_opening || "",
        volunteer_position_id: data?.volunteer_position_id || "",
        days_of_service_id: data?.days_of_service_id || "",
        hours_of_service_id: data?.hours_of_service_id || "",
        joining_date: data?.joining_date || "",
        skills: data?.skills || "",
        live_omtapovan: data?.live_omtapovan || false,
        want_volunteer: data?.want_volunteer || "",
        your_confirmation: data?.your_confirmation || "",
        have_you_volunteered: data?.have_you_volunteered || "",
      });
    }
  }, [getall]);

  const nextStep = () => {
    setPage((currPage) => currPage + 1);
    setSubPage(0);
  };

  const prevStep = () => {
    setPage((currPage) => currPage - 1);
    setSubPage(0);
  };

  const PageDisplay = () => {
    switch (page) {
      case 0:
        return <Step_one nextStep={nextStep} methods={methods} />;
      case 1:
        return <Step_two nextStep={nextStep} prevStep={prevStep} methods={methods} />;
      default:
        return null;
    }
  };

  const stepNames = [];

  return (
    <section className='Volunteer_step_form'>
      <div className='container'>
        <Breadcrumb_Comp data={[
          { label: "EXPLORE", link: "/explore", active: false },
          { label: "Volunteering", link: "/volunteer", active: false },
          { label: volunteer?.name, link: "", active: true },
        ]} />
        <Common_Title_2 subText={'Application For Voluntary: Personal Information'} />

        <FormProvider {...methods}>
          <section className="SellerStepMain">

            <div className="userForm">
              <div className="step-Form-Container">
                {PageDisplay()}
              </div>
            </div>

          </section>
        </FormProvider>
      </div>
    </section>
  );
};

export default Volunteer_step_form;
























// import { useState, useEffect } from "react";
// import './Volunteer_step_form.css'
// import Breadcrumb_Comp from '../../common/common_components/breadcrumb_comp/Breadcrumb_Comp'
// import Common_Title_2 from '../../common/common_components/common_title_2/Common_Title_2'
// import "react-step-progress-bar/styles.css";
// import { ProgressBar, Step } from "react-step-progress-bar";
// import MultiStep from 'react-multistep'
// import Step_one from './step-one/Step_one'
// import Step_two from './step-two/Step_two'
// import { useForm, FormProvider } from "react-hook-form";
// import { useParams } from "react-router-dom";
// import { GetALL } from "../../../features/admin/volunteerStepform/Slice";
// import { useDispatch, useSelector } from "react-redux";
// const Volunteer_step_form = () => {
//        const dispatch = useDispatch();
//     const getall = useSelector((state) => state.volunteerstepform.getall);
//     console.log("getallgetallgetall",getall)

//     useEffect(() => {
//         dispatch(GetALL(
//         ));
//       }, [dispatch]);
//     const breadcrumbs = [
//         { label: "EXPLORE", link: "/explore", active: false },
//         { label: "Volunteering", link: "/volunteer", active: false },
//         { label: "Food Distribution Volunteering", link: "", active: true },
//     ];
//     const { id } = useParams();
//     const [page, setPage] = useState(0);
//     const [subPage, setSubPage] = useState(0);


//     useEffect(() => {
//   if (id) {
//     methods.setValue("volunteering_id", id);
//   }
//   }, [id]);

//     //  React Hook Form initialized here
//     const methods = useForm({
//         mode: "onChange",
//        defaultValues: {
//     // Step One Fields
//     f_name: "",
//     l_name: "",
//     email: "",
//     contact_no: "",
//     volunteering_id: "",
//     volunteer_id: "", // for updating step1 if exists

//     // Step Two Fields
//     learn_about_this_opening: "",
//     volunteer_position_id: "",
//     days_of_service_id: "",
//     hours_of_service_id: "",
//     joining_date: "",
//     skills: "",
//     live_omtapovan: false,
//     want_volunteer: "",
//     your_confirmation: "",
//     have_you_volunteered: "",
// }

//     });

//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, [page, subPage]);

//     const nextStep = () => {
//         if (page === 6 && subPage === 0) {
//             setSubPage(1);
//         } else {
//             setPage((currPage) => currPage + 1);
//             setSubPage(0);
//         }
//     };

//     const prevStep = () => {
//         if (page === 6 && subPage === 1) {
//             setSubPage(0);
//         } else {
//             setPage((currPage) => currPage - 1);
//             setSubPage(0);
//         }
//     };

//     const PageDisplay = () => {
//         switch (page) {
//             case 0:
//                 return (
//                     <Step_one
//                         nextStep={nextStep}
//                         methods={methods} //  Pass RHF methods
//                         heading={stepNames[0]}
//                     />
//                 );
//             case 1:
//                 return (
//                     <Step_two
//                         nextStep={nextStep}
//                         prevStep={prevStep}
//                         methods={methods} //  Pass RHF methods
//                     />
//                 );
//             default:
//                 return null;
//         }
//     };

//     const stepNames = [
//         // "Personal Information",
//         // "Volunteer Details"
//     ];

//     return (
//         <>
//             <section className='Volunteer_step_form'>
//                 <div className='container'>
//                     <Breadcrumb_Comp data={breadcrumbs} />
//                     <Common_Title_2 subText={'Application For Voluntary: Personal Information'} />

//                     {/* Wrap child forms here so they can use same form state */}
//                     <FormProvider {...methods}>
//                         <section className="SellerStepMain">
//                             <div className="ProgressBar">
//                                 <ProgressBar
//                                     percent={(page / (stepNames.length - 1)) * 100}
//                                     filledBackground="#0F3768"
//                                     height="3px"
//                                     style={{ margin: "auto" }}
//                                 >
//                                     {stepNames.map((name, index) => (
//                                         <Step key={index}>
//                                             {({ accomplished }) => (
//                                                 <div
//                                                     style={{
//                                                         backgroundColor: index <= page ? "#0F3768" : "#ffffff",
//                                                         color: index <= page ? "#fff" : "#000000",
//                                                         border: index <= page ? "1px solid #0F3768" : "1px solid #FFFFFF",
//                                                         boxShadow: index <= page ? "none" : "0px 0px 6px #00000029",
//                                                     }}
//                                                     className={`step ${index <= page ? "completed" : ""}`}
//                                                 >
//                                                     <p className="mb-0">{index + 1}</p>
//                                                     <div className="step-name">{name}</div>
//                                                 </div>
//                                             )}
//                                         </Step>
//                                     ))}
//                                 </ProgressBar>
//                             </div>

//                             <div className="userForm">
//                                 <div className="step-Form-Container">
//                                     {PageDisplay()}
//                                 </div>
//                             </div>
//                         </section>
//                     </FormProvider>

//                 </div>
//             </section>
//         </>
//     );
// };

// export default Volunteer_step_form;

















// import { useState, useEffect } from "react";
// import './Volunteer_step_form.css'
// import Breadcrumb_Comp from '../../common/common_components/breadcrumb_comp/Breadcrumb_Comp'
// import Common_Title_2 from '../../common/common_components/common_title_2/Common_Title_2'
// import "react-step-progress-bar/styles.css";
// import { ProgressBar, Step } from "react-step-progress-bar";
// import MultiStep from 'react-multistep'
// import Step_one from './step-one/Step_one'
// import Step_two from './step-two/Step_two'

// const Volunteer_step_form = () => {
//     const breadcrumbs = [
//         { label: "EXPLORE", link: "/explore", active: false },
//         { label: "Volunteering", link: "/volunteer", active: false },
//         { label: "Food Distribution Volunteering", link: "", active: true, },
//     ];

//     // const steps = [
//     //     { title: 'StepOne', component: <Step_one /> },
//     //     { title: 'StepTwo', component: <Step_two /> },
//     // ];

//     // <MultiStep
//     // >
//     //     <Step_one title='StepOne' />
//     //     <Step_two title='StepTwo' />
//     // </MultiStep>

//     const [page, setPage] = useState(0);
//     const [subPage, setSubPage] = useState(0);

//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, [page, subPage]);

//     const nextStep = () => {
//         if (page === 6 && subPage === 0) {
//             setSubPage(1);
//         } else {
//             setPage((currPage) => currPage + 1);
//             setSubPage(0);
//         }
//     };

//     const prevStep = () => {
//         if (page === 6 && subPage === 1) {
//             setSubPage(0);
//         } else {
//             setPage((currPage) => currPage - 1);
//             setSubPage(0);
//         }
//     };

//     const PageDisplay = () => {
//         switch (page) {
//             case 0:
//                 return <Step_one nextStep={nextStep} heading={stepNames[0]} />;
//             case 1:
//                 return <Step_two nextStep={nextStep} prevStep={prevStep} />;

//         }
//     };

//     const stepNames = [
//         // "Business Details",
//         // "product and trade ",
//         // "Certification & License",
//         // "GST/PAN Details",
//         // "Owner Details",
//         // "Bank Details",
//         // "Commission & Onboarding",
//         // "Onboarding Form",
//         // "E Signature",
//     ];

//     return (
//         <>
//             <section className='Volunteer_step_form'>
//                 <div className='container'>
//                     <Breadcrumb_Comp data={breadcrumbs} />
//                     <Common_Title_2 subText={'Application For Voluntary: Personal Information'} />

//                     <section className="SellerStepMain">
//                         <div className="ProgressBar">
//                             <ProgressBar
//                                 percent={(page / (stepNames.length - 1)) * 100}
//                                 filledBackground="#0F3768"
//                                 height="3px"
//                                 style={{ margin: "auto" }}
//                             >
//                                 {stepNames.map((name, index) => (
//                                     <Step key={index}>
//                                         {({ accomplished }) => (
//                                             <div
//                                                 style={{
//                                                     backgroundColor: index <= page ? "#0F3768" : "#ffffff",
//                                                     color: index <= page ? "#fff" : "#000000",
//                                                     border: index <= page ? "1px solid #0F3768" : "1px solid #FFFFFF",
//                                                     boxShadow: index <= page ? "none" : "0px 0px 6px #00000029",
//                                                 }}
//                                                 className={`step ${index <= page ? "completed" : ""}`}
//                                             >
//                                                 <p className="mb-0">{index + 1}</p>
//                                                 <div className="step-name">{name}</div>
//                                             </div>
//                                         )}
//                                     </Step>
//                                 ))}
//                             </ProgressBar>
//                         </div>

//                         <div className="userForm">
//                             <div className="step-Form-Container">
//                                 {PageDisplay()}
//                             </div>
//                         </div>
//                     </section>

//                 </div>
//             </section>
//         </>
//     )
// }

// export default Volunteer_step_form